// extracted by mini-css-extract-plugin
export default {"container":"LinearProgressLabel_container__XAeWI","percentage":"LinearProgressLabel_percentage__UDePR"};